import { atomWithMutation, atomWithQuery } from 'jotai-tanstack-query';
import { instance } from '.';

import { AxiosError } from 'axios';
import { Region, RegionGroup } from '@/types/regions';
import * as _ from 'lodash';

export const regionAtom = atomWithQuery<any, AxiosError, any, [string]>(() => ({
  queryKey: ['REGION'],
  queryFn: async () => {
    const res = await getRegion();
    const resVal: any[] = res.data.data;
    const retVal: Array<RegionGroup> = [];
    _.forEach(_.groupBy(resVal, 'region_group_seq'), (val, key) => {
      const tempArray: any[] = _.filter(
        _.map(val, (mval) => _.pick(mval, ['seq', 'sido', 'sigugun', 'hcode'])),
        (f) => f.seq !== null,
      );
      retVal.push({
        region_group_seq: Number(key),
        name: val[0].name,
        region: _.sortBy(tempArray, 'seq'),
      });
    });
    return retVal;
  },
}));

const getRegion = async () => {
  return await instance.get(encodeURI(`/api_shipping_v2/manage/region`));
};

export const postRegionGroup = async (group_name: string) => {
  return await instance.post('/api_shipping_v2/manage/region_group', { group_name });
};

export const putRegionGroup = async (region_group_seq: number, group_name: string) => {
  return await instance.put('/api_shipping_v2/manage/region_group', { region_group_seq, group_name });
};

export const deleteRegionGroup = async (region_group_seq: number) => {
  return await instance.delete('/api_shipping_v2/manage/region_group/' + region_group_seq, null);
};

export const postRegion = async (body: Region) => {
  return await instance.post('/api_shipping_v2/manage/region', body);
};
export const deleteRegion = async (region_seq: number) => {
  return await instance.delete('/api_shipping_v2/manage/region/' + region_seq, null);
};
